module.exports = __webpack_public_path__ + "img/patient-protection.455d2aaf.svg";